export const getGeoServerWorkspace = () => window.geoServerWorkspace || 'tramandai'

export const geoServerWmsUrl = (workspace = getGeoServerWorkspace()) =>
    `${window.geoServerUrl}/geoserver/${workspace}/wms`

export const qualifiedGeoServerLayer = (layerName, workspace = getGeoServerWorkspace()) =>
    layerName.includes(':') ? layerName : `${workspace}:${layerName}`

export const geoServerLegendUrl = (layerName, workspace = getGeoServerWorkspace()) =>
    `${geoServerWmsUrl(workspace)}?REQUEST=GetLegendGraphic&VERSION=1.0.0&FORMAT=image/png&WIDTH=20&HEIGHT=20&LAYER=${qualifiedGeoServerLayer(layerName, workspace)}`
